$(document).ready(function() {
	
	$('.slider-nav-thumbnails').slick({
		slidesToShow: 500,
		slidesToScroll: 1,
		asNavFor: '.slider',
		dots: false,
		focusOnSelect: true,
		adaptiveHeight: true,
	});

	//remove active class from all thumbnail slides
	$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

	//set active class to first thumbnail slides
	$('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');
   
	// On before slide change match active thumbnail to current slide
	$('.slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		var mySlideNumber = nextSlide;
		$('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
		$('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
   });


	var slider2 = $('.slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		fade: true,
		autoplaySpeed: 50,
		infinite: false,
		cssEase: 'linear',
		nextArrow: '.next_caro',
  		prevArrow: '.previous_caro',
		asNavFor: '.slider-nav-thumbnails',
		swipeToSlide: false,
		swipe: false,
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					swipeToSlide: true,
					swipe: true,
				}
			}
		]
	});

	// script for update the popup transform property starts
	$('.slider')
	.on('afterChange init', function(event, slick, direction){
		// remove all prev/next
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
		// find current slide
		for (var i = 0; i < slick.$slides.length; i++)
		{
			var $slide = $(slick.$slides[i]);
			if ($slide.hasClass('slick-current')) {
				// update DOM siblings
				$slide.prev().addClass('prevSlide');
				$slide.next().addClass('nextSlide');
				break;
			}
		}
		// $('.hex_slider_close').css('opacity','0');
		// setTimeout(() => {
		// 	$('.hex_slider_close').css('opacity','1');
		// }, 300);
	}
	)
	.on('beforeChange', function(event, slick, currentSlide) {
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
		$('.hex_slider_close').css('opacity','0');
		setTimeout(() => {
			$('.hex_slider_close').css('opacity','1');
		}, 300);
	})
	
	$('.hex_slider_close').click(function(){
		$('.hex_single').removeClass('prevSlide').removeClass('nextSlide');
	});
	// $slider.slick();
	
	

	// script for update the popup transform property ends


	

	
	

	$('.hex_speaker_wrapper_single a').click(function() {
		$('.hex_speaker_main_w').addClass('active_main_par');
	});
	
	$('.hex_slider_close').click(function() {
		$('.hex_speaker_main_w').removeClass('active_main_par');
	});
	

	// Menu
	$('.mob_menu_open').click(function(){
		$(this).toggleClass('menu_active');
		$('.hex_menu_items').toggleClass('mob_menu_active');
		// $('header').toggleClass('ov_flow_unset');
		$('body').toggleClass('menu_active_body');
		$('.hex_why_should').toggleClass('overlay_hidden');
	});
	// Menu Ends
	// On scroll Starts
	
	// On scroll Ends
	if ( $(window).width() < 1101 ) {
		$('.hex_menu_items ul li a').click(function() {
			$('.hex_menu_items').removeClass('mob_menu_active');
			$('body').removeClass('menu_active_body');
			// $('header').removeClass('ov_flow_unset');
			$('.mob_menu_open').removeClass('menu_active');
		});
	}
	$(window).resize(function() {
		if ( $(window).width() < 1101 ) {
			$('.hex_menu_items ul li a').click(function() {
				$('.hex_menu_items').removeClass('mob_menu_active');
				$('body').removeClass('menu_active_body');
				// $('header').removeClass('ov_flow_unset');
				$('.mob_menu_open').removeClass('menu_active');
			});
		}
	});
	
	var $carousel = $('.slider');
	$(document).on('keydown', function(e) {
		if(e.keyCode == 37) {
			$carousel.slick('slickPrev');
		}
		if(e.keyCode == 39) {
			$carousel.slick('slickNext');
		}
		if (e.keyCode == 27){
			$(".hex_speaker_main_w").removeClass('active_main_par');
		} 
	});

	$('.mob-next-and-prev .prev-arrow').click(function(){
		$('.mob-next-and-prev .next_arrow').show();
	});
	

	// Ripple Starts
	//Event Listening
	$('.ripple-btn').on('click', rippleAnimation);
  
	/**
	* rippleAnimation
	**/
	function rippleAnimation(e) {
	  //e.preventDefault();
	  $this = $(this);
	  
	  //remove ripple if it's already on
	  $oldRipple = $('.ripple');
	  if($this.has($oldRipple)) $oldRipple.remove();
	  //If your page has more than one button instead of this just do $('.ripple').remove() to remove them all
  
	  //create element
	  $ripple = $(document.createElement('div'));
	  $ripple.addClass('ripple');
  
	  //Get the click's location
	  var eY = e.offsetY;
	  var eX = e.offsetX;
	  
	  //Get the element's width and height
	  var w = $this.width();
	  var h = $this.height();
	  
	  //get the offset of eX and eY
	  var offsetX = Math.abs(w / 2 - eX);
	  var offsetY = Math.abs(h / 2 - eY);
	  
	  //get the delta of X and Y
	  var deltaX = w/2+offsetX;
	  var deltaY = h/2+offsetY;
	  
	  //size
	  //The squareroot of ( deltaX² + deltaY² - 2 * deltaX * deltaY * cos(90°) (in radian = 1/2 PI) ) * 2
	  var size = Math.sqrt( Math.pow(deltaX,2) + Math.pow(deltaY,2) -2 * deltaX * deltaY * Math.cos(Math.PI / 2) ) * 2;
  
	  //apply everything to $ripple
	  $ripple.css({
		'top': eY,
		'left': eX
	  });
	  
	  //and append it
	  $this.append($ripple);
	}
	// Ripple ends
});

// Add data in array starts
var datevalues=[];
$( ".date-select-field" ).bind('click', function () {
	if ($(this).is(':checked')) {
	  if ((index = datevalues.indexOf($(this).attr("data-date"))) !== -1) {
		datevalues.splice(index, 1);
	  }
	  datevalues.push($(this).attr("data-date"));
	}
	else{
	  if ((index = datevalues.indexOf($(this).attr("data-date"))) !== -1) {
		datevalues.splice(index, 1);
	  }
	}
	var dateArrayLen = datevalues.length;
	
	if(dateArrayLen == 0){
		$('.hex_check_box_title').text('Select Date');
	}
	else{
		$('.hex_check_box_title').text(datevalues.join(', '));
		$('.clear-all').show();
	}

});
// Add data in array ends

// Agenda Home page stripe starts
$(document).ready(function() {
	$('#filterOptions li a').click(function() {
	  // fetch the class of the clicked item
	  var ourClass = $(this).attr('class');
	  // reset the active class on all the buttons
	  $('#filterOptions li').removeClass('active');
	  // update the active state on our clicked button
	  $(this).parent().addClass('active');
  
	  if(ourClass == 'all') {
		// show all our items
		$('#ourHolder').children('div.item').show();
	  }
	  else {
		// hide all elements that don't share ourClass
		$('#ourHolder').children('div:not(.' + ourClass + ')').removeClass('active-block');
		// show all elements that do share ourClass
		$('#ourHolder').children('div.' + ourClass).addClass('active-block');
	  }
	  return false;
	});
});
// Agenda Home page stripe ends

// Accordian Starts
$('.hex_acc_identifier').click(function() {
		
	if ($(this).hasClass("active")) {
		$(this).removeClass('active');
		$(this).parent().parent().removeClass('active');
	}
	else{
		$('.hex_acc_identifier').removeClass('active');
		$('.hex_accordian_single').removeClass('active');
		$(this).addClass('active');
		$(this).parent().parent().addClass('active');
	}
});
// Accordian Ends

// Clear Filter starts
$('.clear-all').on('click', function() {
	datevalues.splice(0, datevalues.length);
	$('input.date-select-field').each(function() { 
		this.checked = false; 
	});
	$('input.ag_cat_ses_select').each(function() { 
		this.checked = false; 
	});
	$('input.ag_cat_cat_select').each(function() { 
		this.checked = false; 
	});
	$('.hex_check_box_title').text('Select Date');
	$(this).hide();
	$('.session_select').removeClass('disable_category');
	$('.agenda_cat_select').removeClass('disable_category');
	$('.date-select li label').removeClass('disable_category');
});
// Clear Filter Ends


// Enable and disable category starts
var datevaluesdemo=[];
$( ".date-select-field" ).bind('click', function () {
	$(".date-select-field").each(function(){
		$('.session_select').addClass('disable_category');
		$('.agenda_cat_select').addClass('disable_category');
		if ($(this).is(':checked')) {
			$(this).addClass("checkeditem");

			if ((index = datevaluesdemo.indexOf($(this).attr("data-date"))) !== -1) {
				datevaluesdemo.splice(index, 1);
			}
			datevaluesdemo.push($(this).attr("data-date"));
			
			if ( $('.date-select-field.date_1').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-1 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-1 = true]').removeClass('disable_category');

			}
			if ( $('.date-select-field.date_2').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-2 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-2 = true]').removeClass('disable_category');

			}
			if ( $('.date-select-field.date_3').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-3 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-3 = true]').removeClass('disable_category');

			}

		}
		else{
			$(this).removeClass("checkeditem");
			$('.session_select').addClass('disable_category');
			$('.agenda_cat_select').addClass('disable_category');
			if ((index = datevaluesdemo.indexOf($(this).attr("data-date"))) !== -1) {
				datevaluesdemo.splice(index, 1);
			}

			if ( $('.date-select-field.date_1').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-1 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-1 = true]').removeClass('disable_category');
			}
			if ( $('.date-select-field.date_2').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-2 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-2 = true]').removeClass('disable_category');
			}
			if ( $('.date-select-field.date_3').hasClass( "checkeditem" ) ) {
				$('.session_select[data-date-3 = true]').removeClass('disable_category');
				$('.agenda_cat_select[data-date-3 = true]').removeClass('disable_category');
			}

		}
	});
	if(datevaluesdemo.length == 0){
		// alert(123);
		$('.session_select').removeClass('disable_category');
		$('.agenda_cat_select').removeClass('disable_category');
	}
});


$(".session_select").click(function() {
	$('.date-select-field').parent().addClass('disable_category');
	if($(this).attr('data-date-1') == 'true'){
		$('.date-select-field.date_1').parent().removeClass('disable_category');
	}
	if($(this).attr('data-date-2') == 'true'){
		$('.date-select-field.date_2').parent().removeClass('disable_category');
	}
	if($(this).attr('data-date-3') == 'true'){
		$('.date-select-field.date_3').parent().removeClass('disable_category');
	}
	$('label.disable_category .checkeditem').click();

});
$(".agenda_cat_select").click(function() {
	$('.date-select-field').parent().addClass('disable_category');
	if($(this).attr('data-date-1') == 'true'){
		$('.date-select-field.date_1').parent().removeClass('disable_category');
	}
	if($(this).attr('data-date-2') == 'true'){
		$('.date-select-field.date_2').parent().removeClass('disable_category');
	}
	if($(this).attr('data-date-3') == 'true'){
		$('.date-select-field.date_3').parent().removeClass('disable_category');
	}
	$('label.disable_category .checkeditem').click();
});
// Enable and disable category ends

$('.video_block__wrapper__video_overlay').click(function(){
	$(this).css('display','none');
	$('.hex_custom-play-btn').hide();
	// $('#hex_video_block__vdo').click();
	$("#hex_video_block__vdo")[0].src += "&autoplay=1";
	// $('.hex_register a').click();
});

//    Video registration label flow starts
$( "#partnerVideo .form-group input" ).focus(function() {
	$(this).parent().addClass('hex_focus_in');
	var value = $(this).val();
	var valuelength = value.length;
	if(valuelength > 0){
		$(this).parent().addClass('has_value');
	}
	else{
		$(this).parent().removeClass('has_value');
	}
});

$( "#partnerVideo .form-group input" ).focusout(function() {
	$(this).parent().removeClass('hex_focus_in');
	var value = $(this).val();
	var valuelength = value.length;
	if(valuelength > 0){
		$(this).parent().addClass('has_value');
	}
	else{
		$(this).parent().removeClass('has_value');
	}
});
$("#partnerVideo .form-group select").change(function(){
	if ( $(".sponsor_form .form-group select option:selected").val() === "default" )
	{
		// alert("No items selected");
		$(this).parent().removeClass('has_value');
	}
	else{
		$(this).parent().addClass('has_value');
	}
});
//    Video registration label flow ends

// faq starts
$('.hex_faq__main__single').click(function(){
	$('.hex_faq__main__single .single__description_block').slideUp(300);
	if ($(this).hasClass("single_active")) {
		$(this).removeClass('single_active');
		$(this).find(".single__description_block").slideUp(300);
	}else{
		$('.hex_faq__main__single').removeClass('single_active');
		$(this).addClass('single_active');
		$(this).find(".single__description_block").slideDown(300);
	}
});
function checkactiveFaq(){
	if($('.hex_faq__main__single').hasClass('single_active')){
		$('.hex_faq__main__single.single_active .single__description_block').slideDown(300);
	}
}
$(document).ready(function(){
	checkactiveFaq();
});
$('#faq_btn').click(function(){
	$('.hex_faq').addClass('hex_faq-active');
	$('body').addClass('faq_active_body');
});
// faq ends
// for new header starts
$('.mob_content_close_item').click(function(){
	$('body').removeClass('menu_active_body');
	$('.mob_menu_open').removeClass('menu_active');
});



// $('#usertype').on('change', function() {
// 	if ($(this).val() == "default") {
//   		// return $(this).css('color', 'rgba(#191919,0.5)');
// 		  $('.fixes_form_placeholder').css('visibility','visible');
// 	} else {
//   		$(this).css('color', '#fff');
// 		// $(".fixes_form_placeholder").css('color', '#191919');
// 		$(this).css('z-index', '99');
// 		$('.fixes_form_placeholder').css('visibility','hidden');
// 	}
	
// });

// $('#usertype').on('change', function() {
// 	if ($(this).val() == "partner") {
// 		$('.form_contact').css('display','none');
// 	}
// 	else{
// 		$('.form_contact').css('display','block');
// 	}
// });


// home banner animations starts


/*====================================================================
					SCROLLTRIGGER STARTS
=====================================================================*/
// var locoScroll;
try{
	gsap.registerPlugin(ScrollTrigger);

	function animateAgendaOnScroll(){
		const boxesag = gsap.utils.toArray('.scroll-box-agenda');
		boxesag.forEach((box, i) => {
			const anim = gsap.fromTo(box, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
			$('.hex_scroll_control').css('visibility','visible');
			ScrollTrigger.create({
				trigger: box,
				animation: anim,
				toggleActions: 'play none none none',
				once: true
			});
		});
	}

	document.addEventListener("DOMContentLoaded", function() {
		if(document.querySelector("#scroll-container")){
			const containerEl = document.querySelector("#scroll-container");
	
			document.addEventListener('scroll', function(e) {
				ScrollTrigger.update;
			});
			// tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
			ScrollTrigger.scrollerProxy("#scroll-container", {
				getBoundingClientRect() {
				return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
				},
				
			});
			
			const boxes = gsap.utils.toArray('.scroll-box');
			boxes.forEach((box, i) => {
				const anim = gsap.fromTo(box, {autoAlpha: 0, y: 150}, {duration: 1, autoAlpha: 1, y: 0});
				$('.hex_scroll_control').css('visibility','visible');
				ScrollTrigger.create({
					trigger: box,
					animation: anim,
					toggleActions: 'play none none none',
					once: true
				});
			});
	
			animateAgendaOnScroll();

			const boxesag = gsap.utils.toArray('.scroll-cat-agenda');
			boxesag.forEach((box, i) => {
				const anim = gsap.fromTo(box, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
				$('.hex_scroll_control').css('visibility','visible');
				ScrollTrigger.create({
					trigger: box,
					animation: anim,
					toggleActions: 'play none none none',
					once: true
				});
			});

			function adjustSignupHeight(){
				let signupHeight =  $(".signup-wrap").outerHeight(true);
				signupTrigger.css({'height': signupHeight})
			}

			let signupTrigger = $("#signup-stripe");
			let signupHeight =  $(".signup-wrap").outerHeight(true);
			let heightAnim = gsap.fromTo(signupTrigger, {autoAlpha: 1, height: 0}, {delay: 0.2, duration: .75, height: signupHeight});

			ScrollTrigger.create({
				trigger: signupTrigger,
				animation: heightAnim,
				toggleActions: 'play none none none',
				once: true
			});

			$(window).resize(function() {
				adjustSignupHeight();
			});

			const anim = gsap.fromTo(".signup-container", {autoAlpha: 0, y: -50}, {delay: 1.2, duration: .75, autoAlpha: 1, y: 0});
			ScrollTrigger.create({
				trigger: ".signup-container",
				animation: anim,
				toggleActions: 'play none none none',
				once: true
			});
			ScrollTrigger.refresh(); 


			let listnerId = document.getElementById("sign-up");
			if(listnerId){
				// Options for the observer (which mutations to observe)
				const config = { attributes: true, childList: true, subtree: true };
				// Callback function to execute when mutations are observed
				const callback = function(mutationList, observer) {
					// Use traditional 'for loops' for IE 11
					for(const mutation of mutationList) {
						if (mutation.type === 'childList') {
							setTimeout(() => {
								adjustSignupHeight();
							}, 500);
						}
						// else if (mutation.type === 'attributes') {
						// 	setTimeout(() => {
						// 		adjustSignupHeight();
						// 	}, 500);
						// }
					}
				};
				// Create an observer instance linked to the callback function
				const observer = new MutationObserver(callback);
				// Start observing the target node for configured mutations
				observer.observe(listnerId, config);
			}

		}
	});
} catch(e){
	// console.log(e);
}

/*====================================================================
					SCROLLTRIGGER ENDS
=====================================================================*/

/*====================================================================
								TAB STARTS
=====================================================================*/
$(document).ready(function(){
	// (()=>{  
	
		function mainController() {
			let getControllWrapper= document.querySelectorAll(".mhex_multi_tab_content_wrapper");
			getControllWrapper.forEach((val,index)=>{
				if(val.classList.contains("tab-active")) {
					return
				}
				val.classList.add('tab-active')
				let createLine = document.createElement("div"); 
				createLine.classList.add('line');
				val.querySelector(".mhex_multi_tab_header_nav").appendChild(createLine);
				let getActiveTabIndex= val.querySelector('.mhex_tab_nav_li.active');
				setActiveTab(val,getActiveTabIndex.getAttribute('data-index'));
				setActiveTabEventAdd(val);
			});
		}
	
	
		function setActiveTabEventAdd(passEle) {
			let getHeaderLi= passEle.querySelectorAll(".mhex_tab_nav_li");
			let getFooterLi= passEle.querySelectorAll(".mhex_muliti_tab_footer_nav ul li a");
	
			getHeaderLi.forEach((val,index)=>{
				if(val.addEventListener) {
					val.addEventListener('click',(e)=>{
						e.preventDefault();
						e.stopPropagation();
						setTabData(e,val,passEle,'header-nav');
						// locoScroll.update();

					},false);
				}else {
					val.attachEvent('onclick',(e)=>{
						e.preventDefault();
						e.stopPropagation();
						setTabData(e,val,passEle,'header-nav');
						// locoScroll.update();
					});
				}
			});
			if(getFooterLi) {
				getFooterLi.forEach((val,index)=>{
					if(val.addEventListener) {
						val.addEventListener('click',(e)=>{
							e.preventDefault();
							e.stopPropagation();
							setFooterTabData(e,val,passEle);
							// locoScroll.update();
						},false);
					}else {
						val.attachEvent('onclick',(e)=>{
							e.preventDefault();
							e.stopPropagation();
							setFooterTabData(e,val,passEle);
							// locoScroll.update();
						});
					}
				});
			}
		}
	
		function setTabData(e,val,passEle,type) {
			let setType= "";
			if(type == 'header-nav') {
				setType= ".mhex_tab_nav_li.active";
	
			}else {
				setType=".mhex_muliti_tab_footer_nav ul li.active"
			}
	
			let getActiveTab= passEle.querySelector(setType);
			let getId= val.querySelector('a').getAttribute('href');
			if(getActiveTab.querySelector('a').getAttribute('href') == `${getId}`) {
				return;
			}
			let getOldTabIndex= getActiveTab.getAttribute("data-index");
			getActiveTab.classList.remove('active');
			e.target.closest('li').classList.add('active');
			if(type == 'header-nav') {
				let getFooterActiveTab= passEle.querySelector(".mhex_muliti_tab_footer_nav ul li.active");
				(_getFooterActiveTab = getFooterActiveTab) === null || _getFooterActiveTab === void 0 ? void 0 : _getFooterActiveTab.classList.remove('active');
				let getNewIndex= passEle.querySelector(".mhex_tab_nav_li.active").getAttribute("data-index");
				(_passEle$querySelecto = passEle.querySelectorAll(".mhex_muliti_tab_footer_nav ul li")[parseInt(getNewIndex)]) === null || _passEle$querySelecto === void 0 ? void 0 : _passEle$querySelecto.classList.add('active');
			}
			
			setActiveTab(passEle,getOldTabIndex, type);
		}
	
		function setFooterTabData(e,val,passEle,type='') {
	
			let getActiveTab= passEle.querySelector(".mhex_muliti_tab_footer_nav ul li.active");
			let getId= val.getAttribute('id');
			if(getActiveTab.querySelector('a').getAttribute('href') == `#${getId}`) {
				return
			}
	
			getActiveTab.classList.remove('active');
			e.target.parentElement.classList.add('active');
			if(type != 'header-nav') {
				let getNewTabIndex= (e.target).getAttribute("data-index");
				let getnavLi= passEle.querySelectorAll(".mhex_tab_nav_li");
				getnavLi[parseInt(getNewTabIndex)].querySelector('a').click();
			}
			
		}
		
		function setActiveTab( passEle, getOldTabIndex, type="header-nav") {
			if( passEle == null) {
				return false;
			}
			let setType= '';
			let scrollMove= '';
			if(type == 'header-nav') {
				setType= ".mhex_tab_nav_li.active";
	
			}else {
				setType=".mhex_muliti_tab_footer_nav ul li.active";
			}
			
			let getActiveTab= passEle.querySelector(".mhex_tab_nav_li.active");
			let getNewTabIndex= getActiveTab.getAttribute("data-index");
			let animationType= "";
	
			let getActiveEleWidth= getComputedStyle(getActiveTab).width;
			let getParentNav= passEle.querySelector(".mhex_multi_tab_header_nav");
			let headerNavParentWidth= getComputedStyle(getParentNav.parentElement).width;
			getParentNav.setAttribute('data-width', headerNavParentWidth);
			let getNavListWidth= getParentNav.querySelector("ul").scrollWidth;
			
			let getRightPositionValue= getNavListWidth - (getActiveTab.offsetLeft + splitNumber(getActiveEleWidth));
	
			if(parseInt(getOldTabIndex) > parseInt(getNewTabIndex)) {
				passEle.querySelector(".line").setAttribute("style",`right: ${getRightPositionValue}px; left: ${getActiveTab.offsetLeft}px; transition: right 0.6s ease, left 0.63s ease`);
				// $(".line").animate({left: getActiveTab.offsetLeft}, 400 ); 
				animationType= 'mhex__tab_content_from_right';
				scrollMove= 'right';
			}else {
				passEle.querySelector(".line").setAttribute("style",`right: ${getRightPositionValue}px; left: ${getActiveTab.offsetLeft}px; transition: left 0.6s ease, right 0.63s ease`);
				// $(".line").animate({left: getActiveTab.offsetLeft}, 400 ); 
				animationType= 'mhex__tab_content_from_left';
				scrollMove= 'left';
			}
	
			let checkScroll= isScrollCheck(passEle);
			if ((_checkScroll = checkScroll) !== null && _checkScroll !== void 0 && _checkScroll.scroll) {
				passEle.querySelector(".line").setAttribute("style",`width: ${getActiveEleWidth}; left: ${getActiveTab.offsetLeft}px; transition: all 0.4s ease`); 
				// $(".line").css({width: getActiveEleWidth});
				// $(".line").animate({left: getActiveTab.offsetLeft}, 400 ); 
				let getNavParent= passEle.querySelector(".mhex_multi_tab_header");
				let getLiWidth= parseFloat(splitNumber(getActiveEleWidth));
				let setScrollWidth= getActiveTab.offsetLeft - ((checkScroll.parentWidth - getLiWidth) / 2);
				let getNextLiWidth= 0;
				let getPrevLiWidth = 0;
				if ((_getActiveTab = getActiveTab) !== null && _getActiveTab !== void 0 && _getActiveTab.nextElementSibling) {
					getNextLiWidth= splitNumber(getComputedStyle(getActiveTab.nextElementSibling).width);
				}
				if ((_getActiveTab = getActiveTab) !== null && _getActiveTab !== void 0 && _getActiveTab.previousElementSibling) {
					getPrevLiWidth= splitNumber(getComputedStyle(getActiveTab.previousElementSibling).width);
				}
	
				let calcLi= 0;
				if(scrollMove == 'left') {
					calcLi= getActiveTab.offsetLeft + getLiWidth + getNextLiWidth;
					if((calcLi > checkScroll.parentWidth) || (getActiveTab.offsetLeft > checkScroll.parentWidth)) {
						// getNavParent.scroll({
						// 	left: setScrollWidth,
						// 	behavior: 'smooth'
						// })
						$('.mhex_multi_tab_header').animate({
							scrollLeft: setScrollWidth
						},{
							duration: 150,
							easing: "linear"
						});
					}
				}else {
					calcLi= getActiveTab.offsetLeft + getLiWidth + getPrevLiWidth;
					if((calcLi < checkScroll.parentWidth) || (getActiveTab.offsetLeft > setScrollWidth)) {
						// getNavParent.scroll({
						// 	left: setScrollWidth,
						// 	behavior: 'smooth'
						// })
						$('.mhex_multi_tab_header').animate({
							scrollLeft: setScrollWidth
						},{
							duration: 150,
							easing: "linear"
						});
					}
				}
			}else {
			}
			setTabContentChange(passEle,getActiveTab,animationType);
			
		}
	
	
		function setTabContentChange(passEle,passActiveTab,passAnimationType) {
			
			let getActiveTabContent= passEle.querySelector(".mhex_multi_tab_content.active");
			let getId= passActiveTab.querySelector('a').getAttribute("href");
			let getRightAnimationActive= passEle.querySelector(".mhex__tab_content_from_right");
			let getLeftAnimationActive= passEle.querySelector(".mhex__tab_content_from_left");
			if(getRightAnimationActive) {
				getRightAnimationActive.classList.remove("mhex__tab_content_from_right");
			}
			if(getLeftAnimationActive) {
				getLeftAnimationActive.classList.remove("mhex__tab_content_from_left");
			}
			
			getActiveTabContent.classList.remove('active');
			passEle.querySelector(`${getId}`).classList.add('active',passAnimationType);
			// var win = $(this);
			// if(win.width()>=767){

			setheightchange();
			// }
			setheight(passEle.querySelector(`${getId}`).dataset.height);
		}
	
		function isScrollCheck(passEle) {
			let getParentNav= passEle.querySelector(".mhex_multi_tab_header_nav");
			let getNavListWidth= getParentNav.querySelector("ul").scrollWidth;
			let getParentWidth= splitNumber(getParentNav.getAttribute('data-width'));
			let getActiveNavLi= passEle.querySelector('.mhex_tab_nav_li.active');
			
	
			if(Math.round(parseFloat(getParentWidth)) < getNavListWidth) {
				return {
					scroll: true,
					parentWidth: parseFloat(getParentWidth),
					navWidth: getNavListWidth,
					getActiveNavLi: getActiveNavLi
				};
			}
		}
	
		function splitNumber(passData) {
			let splitNuber= passData.split( "px" );
			return parseFloat(splitNuber);
		}
	
		window.onresize= function(){
			setheightchange();
			let getControllWrapper= document.querySelectorAll(".mhex_multi_tab_content_wrapper");
			getControllWrapper.forEach((val,index)=>{
				let getActiveTabIndex= val.querySelector('.mhex_tab_nav_li.active');
				setTimeout(()=>{
					setActiveTab(val,getActiveTabIndex.getAttribute('data-index'));
				},400)
			});
			
		}
		mainController();
		function setheight(obj){
			var win = $(this);
			if(win.width()>=769){
				$('.mhex_second_tab_content_wrapper').first().height(obj);

			}else{
				$('.mhex_second_tab_content_wrapper').first().height("auto");
			}
			
		}
	// })();
	function setheightchange(){
		var win = $(this);

		if(win.width()>=769){

		$('.mhex_multi_tab_content').each(function(i, obj) {
			let val = $(this).height();
			$(this).attr('data-height',`${val}`);
		});

		$('.mhex_second_tab_content_wrapper').each(function(i, obj) {
			let val = $(this).height();
			// console.log(val);
			$(this).css('height',`${val}`);		
			$('.mhex_multi_tab_content').first().attr('data-height',`${val}`);
		});
	}
	};
	setheightchange();
})

/*====================================================================
								TAB ENDS
=====================================================================*/

// Custom scroll trigger starts
function xMovement(className, count){
	if( $('div').hasClass(className) ){
		gsap.to("."+className, {
			xPercent: count,
			ease: "none",
			scrollTrigger: {
				trigger: "."+className,
				scrub: 1
			}, 
		});
	}
	else{
		if( $('img').hasClass(className) ){
			gsap.to("."+className, {
				xPercent: count,
				ease: "none",
				scrollTrigger: {
					trigger: "."+className,
					scrub: 1
				}, 
			});
		}
	}
}
function yMovement(className, count){
	if( $('div').hasClass(className) ){
		gsap.to("."+className, {
			yPercent: count,
			ease: "none",
			scrollTrigger: {
				trigger: "."+className,
				scrub: 1
			}, 
		});
	}
	else{
		if( $('img').hasClass(className) ){
			gsap.to("."+className, {
				yPercent: count,
				ease: "none",
				scrollTrigger: {
					trigger: "."+className,
					scrub: 1
				}, 
			});
		}
	}
	
}
function rotateClockWise(className, count){
	if( $('div').hasClass(className) ){
		gsap.to(`.${className}`, {
			rotation:360*5,
			// duration:3000,
			ease:'none',
			scrollTrigger:{
			trigger: `.${className}`,
			scrub:0.2,
			end:'+=10000',
			}
		})
	}
	else{
		if( $('img').hasClass(className) ){
			gsap.to(`.${className}`, {
				rotation:360*5,
				// duration:3000,
				ease:'none',
				scrollTrigger:{
				trigger: `.${className}`,
				scrub:0.2,
				end:'+=10000',
				}
			})
		}
	}
}

function rotateAntiClockWise(className, count){
	if( $('div').hasClass(className) ){
		gsap.to(`.${className}`, {
			rotation:-360*5,
			ease:'none',
			scrollTrigger:{
			trigger: `.${className}`,
			scrub:0.2,
			end:'+=10000',
			}
		})
	}
	else{
		if( $('img').hasClass(className) ){
			gsap.to(`.${className}`, {
				rotation:-360*5,
				ease:'none',
				scrollTrigger:{
				trigger: `.${className}`,
				scrub:0.2,
				end:'+=10000',
				}
			})
		}
	}
}

var videoGreenBoxWrap = 'video-green-shape-wrap--animate';
yMovement(videoGreenBoxWrap, -120);

var videoGreenBox ='video-green-shape--animate';
rotateAntiClockWise(videoGreenBox);
yMovement(videoGreenBox, -40);

var videoBlueBoxWrap = 'video-blue-shape-wrap--animate'
yMovement(videoBlueBoxWrap, 120);

var videoBlueBox = 'video-blue-shape--animate';
yMovement(videoBlueBox, 40);
rotateClockWise(videoBlueBox);



var pinkBox = 'pink-box--animate';
rotateClockWise(pinkBox);
yMovement(pinkBox, 90);

var pinkTrinagleWrap = 'pink-box-triangle__wrap--animate';
yMovement(pinkTrinagleWrap, 10);
var pinkWrap = 'pink-box-wrap--animate';
yMovement(pinkWrap, 120);

var yellowWrap = 'yellow-box-wrap--animate'
yMovement(yellowWrap, -120)

var yellowSquareWrap = 'yellow-box-square__wrap--animate';
yMovement(yellowSquareWrap, -10);

var yellowBox = 'yellow-box--animate';
yMovement(yellowBox, -90)
rotateAntiClockWise(yellowBox);


// sign up elements movement starts //
var signUpOrangeBoxWrap = 'signup-orange--box-wrap-move';
yMovement(signUpOrangeBoxWrap, 80);

var signupOrangeSquareBox = 'signup-orange--box-square-move';
yMovement(signupOrangeSquareBox, 15);

var signupOrangeBox = 'signup-orange--box-move';
yMovement(signupOrangeBox, 50);
rotateClockWise(signupOrangeBox);


var signUpYellowBoxWrap = 'signup-yellow--box-wrap-move';
yMovement(signUpYellowBoxWrap, -90);

var signupYellowSquareBox= 'signup-yellow--box-square-move';
yMovement(signupYellowSquareBox, 15);

var signupYellowBox = 'signup-yellow--box-move';
yMovement(signupYellowBox, -50);
rotateClockWise(signupYellowBox);

// sign up elements movement ends //

// featured speaker movement starts//

var featSpeakersPurpleBox = 'featured-speaker-purple--box-move';
yMovement(featSpeakersPurpleBox, 80)
rotateClockWise(featSpeakersPurpleBox);

var featSpeakersOutlineBox = 'featured-speaker-outline--box-move';
xMovement(featSpeakersOutlineBox, 80)
rotateClockWise(featSpeakersOutlineBox);

// featured speaker movement ends//


// agenda element movement starts //

var agendaPurpleBoxWrap = 'agenda-purple-box--wrap-move';
yMovement(agendaPurpleBoxWrap, -80);

var agendaPurpleBoxSquare = 'agenda-purple-box--square-move';
yMovement(agendaPurpleBoxSquare, -15);

var agendaPurpleBox = 'agenda-purple-box--move';
yMovement(agendaPurpleBox, -80);
rotateAntiClockWise(agendaPurpleBox);


var agendaPinkBoxWrap = 'agenda-pink-box--wrap-move';
yMovement(agendaPinkBoxWrap, 80);

var agendaPinkBoxTriangle = 'agenda-pink-box--triangle-move';
yMovement(agendaPinkBoxTriangle, 15);

var agendaPinkBox = 'agenda-pink-box--move';
yMovement(agendaPinkBox, 60);
rotateClockWise(agendaPinkBox);

var agendOutlineBox = 'agenda-outline--box-move';
xMovement(agendOutlineBox, -60);
rotateAntiClockWise(agendOutlineBox);

// agenda element movement ends //

// media partner movement starts //
var mediaOutlineBox = 'media-outline--box-move';
yMovement(mediaOutlineBox, 60);
rotateClockWise(mediaOutlineBox);

var mediaStarMove = 'media-speaker--star-move';
yMovement(mediaStarMove, -60);

// media partner movement ends //

var sponsorOutlineBox = 'sponsor-outline--box-move';
yMovement(sponsorOutlineBox, 60);
rotateAntiClockWise(sponsorOutlineBox);

// speaker element movement starts//

var speakerGreenBoxWrap = 'speaker-green-box--wrap-move';
yMovement(speakerGreenBoxWrap, -120);

var speakerGreenBoxCircle = 'speaker-green-box--circle-move';
yMovement(speakerGreenBoxCircle, -15);

var speakerGreenBox = 'speaker-green-box--move';
yMovement(speakerGreenBox, -70);
rotateAntiClockWise(speakerGreenBox);

var speakerOrangeBoxWrap = 'speaker-orange-box--wrap-move';
yMovement(speakerOrangeBoxWrap, 80);

var speakerOrangeBoxSquare = 'speaker-orange-box--square-move';
yMovement(speakerOrangeBoxSquare, 15);

var speakerOrangeBox = 'speaker-orange-box--move';
yMovement(speakerOrangeBox, 50);
rotateClockWise(speakerOrangeBox);

// speaker element movement ends//


// sponser element movement starts//

var sponserPurpleBoxWrap = 'sponsor-purple-box--wrap-move';
yMovement(sponserPurpleBoxWrap, 80);

var sponserPurpleBoxSquare = 'sponsor-purple-box--square-move';
yMovement(sponserPurpleBoxSquare, 15);

var sponserPurpleBox = 'sponsor-purple-box--move';
yMovement(sponserPurpleBox, 50);
rotateClockWise(sponserPurpleBox);


var sponserBlueBoxWrap = 'sponsor-blue-box--wrap-move';
yMovement(sponserBlueBoxWrap, -120);

var sponserBlueBoxTriangle = 'sponsor-blue-box--triangle-move';
yMovement(sponserBlueBoxTriangle, -12);

var sponserBlueBox = 'sponsor-blue-box--move';
yMovement(sponserBlueBox, -40);
rotateAntiClockWise(sponserBlueBox);
// sponser element movement ends//


// thank you page elemets movement starts//
var thankYouOrangeBoxWrap = 'thankyou-orange--box-wrap-move';
yMovement(thankYouOrangeBoxWrap, -90);

var thankYouOrangeBoxSquare = 'thankyou-orange--box-square-move'
yMovement(thankYouOrangeBoxSquare, -15);

var thankYouOrangeBox = 'thankyou-orange--box-move';
rotateAntiClockWise(thankYouOrangeBox);
yMovement(thankYouOrangeBox, -60);
// thank you page elemets movement ends//

// past speaker elements movement starts//
var pastSpeakersOutlineBoxMove = 'past-speaker-outline--box-move'
rotateClockWise(pastSpeakersOutlineBoxMove);
yMovement(pastSpeakersOutlineBoxMove, 60);

var pastSpeakersStarMove = 'past-speaker--star-move';
yMovement(pastSpeakersStarMove, -60);

// past speaker elements movement ends//

//banner elements movement starts//

var bannerOrangeBoxWrap  = 'banner-orange-box--wrap-move'
yMovement(bannerOrangeBoxWrap, -80);

var bannerOrangeSquareMove = 'banner-orange-box--square-move';
yMovement(bannerOrangeSquareMove, -5);

var bannerOrangeBoxMove ='banner-orange-box--move'
yMovement(bannerOrangeBoxMove,-120);
rotateAntiClockWise(bannerOrangeBoxMove);

var bannerBlueBoxWrap  = 'banner-blue-box--wrap-move'
yMovement(bannerBlueBoxWrap, -80);

var bannerBlueTriangleMove = 'banner-blue-box--triangle-move';
yMovement(bannerBlueTriangleMove, -5);

var bannerBlueBoxMove ='banner-blue-box--move'
yMovement(bannerBlueBoxMove,-120);
rotateAntiClockWise(bannerBlueBoxMove);


//agenda inner page elements animations start //

var agendaYellowBoxWrap = 'agenda-yellow--box-wrap-animate';
yMovement(agendaYellowBoxWrap, 120);
var agendaYellowSquareBox = 'agenda-yellow--box-square-animate';
yMovement(agendaYellowSquareBox, 10);
var agendaYellowBox = 'agenda-yellow--box-animate';
rotateClockWise(agendaYellowBox);
yMovement(agendaYellowBox, 90);

var agendaGreenBoxWrap = ' agenda-green-wrap--animate';
yMovement(agendaGreenBoxWrap, -90);
var agendaGreenCircleWrap = 'agenda-green-wrap--animate-circle';
yMovement(agendaGreenCircleWrap, -60);
var agendaGreenBox = 'agenda-green--box-animate';
rotateAntiClockWise(agendaGreenBox);
yMovement(agendaGreenBox, -100);

// agenda inner page elements animations ends//


$(window).scroll(function(){
    if ($(this).scrollTop() > 40) {
       $('.banner-purple-box--wrap-move').addClass('position--changes');
	   $('.banner-green-box--wrap-move').addClass('position--changes');
    } else {
       $('.banner-purple-box--wrap-move').removeClass('position--changes');
	   $('.banner-green-box--wrap-move').removeClass('position--changes');
    }
});

//banner elements movement ends//



var leftElParWrap = 'left_element_par__wrap';
yMovement(leftElParWrap, 80);

var lShapeShadow = 'hex_l_shape_shadow';
yMovement(lShapeShadow, 80);

var mirrorCircle = 'video_item__mirrored_circle';
yMovement(mirrorCircle, 70);

var rightParWrap = 'right_element_par__wrap';
yMovement(rightParWrap, -120);

var circleShapeShadow = 'hex_circle_shape_shadow';
yMovement(circleShapeShadow, -120);

var mirrorTriangle = 'video_item__mirrored_triangle';
yMovement(mirrorTriangle, -75);

var horizonShapeImg = 'hex_horizon_shape__image_block';
yMovement(horizonShapeImg, -80);

var signUpLeftIcBlock = 'signup__left_cube_icon__block';
yMovement(signUpLeftIcBlock, -80);

var signUpLeftIcBlockOverlay = 'signup__left_cube_icon__block__circle-ovly';
yMovement(signUpLeftIcBlockOverlay, -80);


var blockOne = 'blocks--one';
yMovement(blockOne, 55);
var blockTwo = 'blocks--two';
yMovement(blockTwo, 51);
var blockThree = 'blocks--three';
yMovement(blockThree, 47);
var blockFour = 'blocks--four';
yMovement(blockThree, 51);
var blockFive = 'blocks--five';
yMovement(blockFive, 51);
var blockSix = 'blocks--six';
yMovement(blockSix, 40);
var blockSeven = 'blocks--seven';
yMovement(blockSeven, 45);
var blockEight = 'blocks--eight';
yMovement(blockEight, 40);
var blockNine = 'blocks--nine';
yMovement(blockNine, 43);
var blockTen = 'blocks--ten';
yMovement(blockTen, 47);
var blockEleven = 'blocks--eleven';
yMovement(blockEleven, 50);
var blockTw = 'blocks--twelve';
yMovement(blockTw, 45);
var blockThir = 'blocks--thirteen';
yMovement(blockThir, 47);
var blockFourteen = 'blocks--fourteen';
yMovement(blockFourteen, 51);
var blockFifteen = 'blocks--fifteen';
yMovement(blockFifteen, 55);

var comShapes = 'shape_inner_item__with_shadow';
var shapeOne = 'shape--one';
yMovement(shapeOne, 50);
var shapeTwo = 'shape--two';
yMovement(shapeTwo, -40);
var shapeThree = 'shape--three';
yMovement(shapeThree, -45);
var shapeFour = 'shape--four';
yMovement(shapeFour, -43);
var shapeFive = 'shape--five';
yMovement(shapeFive, -47);
var shapeSix = 'shape--six';
yMovement(shapeSix, -43);
var shapeSeven = 'shape--seven';
yMovement(shapeSeven, 43);
var shapeEight = 'shape--eight';
yMovement(shapeEight, 51);


var pyraIconBlock = 'signup-right-pyramid-block';
xMovement(pyraIconBlock, -80);

var pyramidSquareOverlay = 'signup-right-pyramid-block__overlay';
xMovement(pyramidSquareOverlay, -80);

var pyraIconBlock = 'signup-right-pyramid-block--awards';
xMovement(pyraIconBlock, 80);

var pyramidSquareOverlay = 'signup-right-pyramid-block--overlay-awards';
xMovement(pyramidSquareOverlay, 80);


var horizontalAboveFooter = 'horizontal_move_img';
xMovement(horizontalAboveFooter, -80);

// Custom scroll trigger ends
// menu item active starts

$('.menu-item a').click(function(){
	$('.menu-item a').removeClass('active');
	$(this).addClass('active');
	setTimeout(() => {
		var hash = window.location.hash.replace("#", "");
		var offset = $('#'+hash).offset();
		var topOffset = offset.top;
		window.scrollTo({ top: topOffset-70, behavior: 'smooth' });
	}, 50);
});
// menu item active ends
$('.ah_ag_filter_btn').click(function(){
	$(this).toggleClass('toggle_btn_active');
});

$( window ).resize(function() {
	if ($(window).width() <= 1100) {
		$('.hex_menu_items').css('display','none');
		setTimeout(() => {
			$('.hex_menu_items').css('display','block');
		}, 200);
	}
});


// File upload customization starts

$("#casestudy").change(function(){
    var fileName = this.files[0].name; //variable for filename
	var fileExtension = fileName.split('.').pop(); //variable for file extension
	var _size = this.files[0].size;
	var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
	i=0;while(_size>900){_size/=1024;i++;}
	var exactSize = (Math.round(_size*100)/100)+' '+fSExt[i]; //variable for file size

	$('.hex_nomination_field--casestudy').addClass('file-uploaded');

	$('.hex_nomination_field--casestudy .hex_nomination_forms__after__file_extension').text("."+fileExtension);
	$('.hex_nomination_field--casestudy .hex_nomination_forms__after__filename').text(fileName);
	$('.hex_nomination_field--casestudy .hex_nomination_forms__after__filesize').text(exactSize);

	$('.hex_nomination_forms__file_block label.error').css('display','none');
	
});

$("#corporatelogo").change(function(){
    var fileName = this.files[0].name; //variable for filename
	var fileExtension = fileName.split('.').pop(); //variable for file extension
	var _size = this.files[0].size;
	var fSExt = new Array('Bytes', 'KB', 'MB', 'GB'),
	i=0;while(_size>900){_size/=1024;i++;}
	var exactSize = (Math.round(_size*100)/100)+' '+fSExt[i]; //variable for file size

	$('.hex_nomination_field--clogo').addClass('file-uploaded');


	$('.hex_nomination_field--clogo .hex_nomination_forms__after__file_extension').text("."+fileExtension);
	$('.hex_nomination_field--clogo .hex_nomination_forms__after__filename').text(fileName);
	$('.hex_nomination_field--clogo .hex_nomination_forms__after__filesize').text(exactSize);

	$('.hex_nomination_forms__file_block label.error').css('display','none');

});

$('.hex_nomination_field--casestudy .hex_nomination_forms__after__remove').click(function(){
	$('#casestudy').val("");
	$('.hex_nomination_field--casestudy').removeClass('file-uploaded');
});

$('.hex_nomination_field--clogo .hex_nomination_forms__after__remove').click(function(){
	$('#corporatelogo').val("");
	$('.hex_nomination_field--clogo').removeClass('file-uploaded');
});

// File upload customization ends

// Nomination form movements updates starts


//Thankyou pages

$(document).on('click', function (event) {
	if (!$(event.target).closest('#thankyou-dropdown').length) {
		$('.thank-you__dropdown').removeClass('active');
		$(".thank-you__dropdown-items-wrap").slideUp(300);
	}
});

$(document).on('click','#thankyou-dropdown',function(){
	if($('.thank-you__dropdown').hasClass('active')){
		$(this).parent().removeClass('active');
		$(".thank-you__dropdown-items-wrap").slideUp(300);
	} else {
		$(this).parent().addClass('active');
		$(".thank-you__dropdown-items-wrap").slideDown(300);
	}
});

$(document).ready(function(){
    var device = navigator.userAgent;
    
    $('.digit-group').find('input').each(function() {
        $(this).attr('maxlength', 1);
        $(this).on('keydown', function(e){
            
            if (!((((e.keyCode >= 96 && e.keyCode <= 105) || (e.keyCode >= 48 && e.keyCode <= 57)) ) || e.keyCode == 8 || e.keyCode == 9 || (e.keyCode == 16 && e.keyCode == 9) || e.keyCode == 46 || e.keyCode == 13 || ((e.keyCode >=65 && e.keyCode <= 91) && (e.ctrlKey || e.metaKey) ))) {
                e.preventDefault();
            }
        });

        $(this).on('keyup', function(e) {
        
            var parent = $($(this).parent());
            if (((e.keyCode >= 96 && e.keyCode <= 105) || (e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode === 39)) { 
                var next = parent.find('input#' + $(this).data('next'));
                if(next.length) {
                    $(next).focus();
                } else {
                    if(parent.data('autosubmit')) {
                        parent.submit();
                    }
                }
            }
            if(e.keyCode == 8 || e.keyCode === 37 || e.keyCode === 46) {
                var prev = parent.find('input#' + $(this).data('previous'));
            
                if(prev.length) {
                    $(prev).focus();
                }
            }
        });

    });
});

var $inputs = $(".otp_text_box");
var intRegex = /^\d+$/;

    $inputs.on("paste", function(e){

    

    $(".form_inline_otp input").removeClass('error_field');
    $("#otpSubmit i").addClass("display_hidden");
    var userdata_error = {};
    var userdata = {};
    
    $(".form_inline_wrap").removeClass("otp_not_valid");
    $(".form_inline_wrap").removeClass("error_shown");
    $(".otp_text_box").removeClass('invalid');
    $("label.error").hide();
    $("#addedOTP").hide();

    var selection = window.getSelection();
    var clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
    var txt = clipboardData.getData('text');
    var x = txt.replace('-','');
    x = x.replace(/ /g,'');
    try {
        if (isNaN(parseInt(x))) {
            e.preventDefault()
            // console.log('if');
        }
        else{
            $("#firstNum").val(x[0]);
            $("#secondNum").val(x[1]);
            $("#thirdtNum").val(x[2]);
            $("#fourthNum").val(x[3]);
            $("#fifthNum").val(x[4]);
            $("#sixthNum").val(x[5]);
        }   
    } catch (e) {
        // console.log(e);
    }
});

// Prevents user from manually entering non-digits.
$inputs.on("input.fromManual", function(){
    if(!intRegex.test($(this).val())){
        $(this).val("");
    }
});

$('.rsend_otp_btn').click(function(){
    $('#firstNum').val('');
    $('#secondNum').val('');
    $('#thirdtNum').val('');
    $('#fourthNum').val('');
    $('#fifthNum').val('');
    $('#sixthNum').val('');
    $(".form_inline_otp input").removeClass("error_field");
    $("#partnername-error").hide();
    $("#invalidOTP").hide();
    $("#expiredOTP").hide();
    $("#usedOTP").hide();
});

	// Partners Slider Starts
	$('.hex_past_speakers_full').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		nextArrow: '.next_partner',
  		prevArrow: '.prev_partner',
		unslick: true,
		responsive: [
		{
			breakpoint: 1150,
			settings: {
			slidesToShow: 3,
			slidesToScroll: 1
			}
		},
		{
			breakpoint: 768,
			settings: {
			slidesToShow: 2,
			slidesToScroll: 1
			}
		},
		{
			breakpoint: 601,
			settings: {
				unslick: true,
				slidesToShow: 1000,
				autoplay: false,
				prevArrow: false,
				nextArrow: false,
			}
		}

		]
	});
	// Partners slider Ends

	handleLocalStorageData("initiate"); // page rendering time we are encrypt the before saved prefilled data

/************************** START: localstorage converter **********************************************/
async function handleLocalStorageData(passType, passData = "") {
	let get_local_storage_data = "";
	let checkEncodedValue = localStorage.getItem("hex_prefilled_form");
	if (checkEncodedValue && (passType == "initiate")) {
		return
	}
	if (passType == "initiate") {
		get_local_storage_data = localStorage.getItem("prefilled_form");
	} else if (passType == "set_data") {
		get_local_storage_data = passData;
	}
	if (get_local_storage_data) {
		try {
			let dataConverter = btoa(get_local_storage_data);
			localStorage.setItem("hex_prefilled_form", dataConverter);
			// localStorage.removeItem("prefilled_form");
		} catch (error) { }
	}

}
/************************** End: localstorage converter ************************************************/

function checkAutoPreFillForm(pass_ele){
	let getInput= document.querySelector(`${pass_ele} [data-store=number]`)
	if(getInput){
		setCountryCodeAutofill(getInput);
	}
	let getFormEle= document.querySelectorAll(pass_ele+" .set-data");
	if(getFormEle){
		let getAutoPreFillData= localStorage.getItem("prefilled_form");
		let getHexPrefilledData= localStorage.getItem("hex_prefilled_form");
		if(getHexPrefilledData) {
			getAutoPreFillData = atob(getHexPrefilledData);
		}
		if(getAutoPreFillData){
			let local_form_data = JSON.parse(getAutoPreFillData);
			getFormEle.forEach((ele,index)=>{
				let getDataAttribute= ele.getAttribute("data-store");
				if(local_form_data.hasOwnProperty(getDataAttribute)){
					let addClass= ele.getAttribute("data-class");
					ele.value= local_form_data[getDataAttribute];
					if(addClass){
						ele.parentElement.classList.add(addClass);
					}
					if(getDataAttribute == "devices") {
						ele.classList.add("valid");
					}
				}
			}); 
		}
	}
}

function setAutoPreFillForm(pass_ele) {
	let getFormEle = document.querySelectorAll(pass_ele + " .set-data");
	var autofillJson = {};

	let get_encoded_storage_data = localStorage.getItem("hex_prefilled_form");
	let get_local_storage_data = localStorage.getItem("prefilled_form");
	let string_data = "";
	let merge_data = {};
	let subject_data = {};

	getFormEle.forEach((ele, index) => {
		let getDataAttribute = ele.getAttribute("data-store");
		if (getDataAttribute) {
			autofillJson = { ...autofillJson, [getDataAttribute]: (ele.value == "on") ? true : ele.value }
		}
	});

	subject_data = autofillJson;

	try {
		if (get_encoded_storage_data) {
			let convertJsonData = JSON.parse(atob(get_encoded_storage_data));
			merge_data = {
				...convertJsonData,
				...subject_data
			}
			string_data = JSON.stringify(merge_data);
		} else if (get_local_storage_data) {
			let convertJsonData = JSON.parse(get_local_storage_data);
			merge_data = {
				...convertJsonData,
				...subject_data
			}
			string_data = JSON.stringify(merge_data);
		} else {
			string_data = JSON.stringify(subject_data);
		}

	} catch (error) {
		string_data = JSON.stringify(subject_data);
	}

	handleLocalStorageData("set_data", string_data);
}

function setCountryCodeAutofill(getInput) {
	let getCuntryCodeCookie= get_cookie('user_calling_code');
	if(getCuntryCodeCookie) {
		getInput.value= `+${getCuntryCodeCookie}-`;
	}
}

/****************************************************************************
	* get value from cookies *
* **************************************************************************/
function get_cookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}